// ----------------------------------------------------------------------
// Design tokens (dark-only) — contrast-tuned
// Three-shade elevation ramp: bg (page) < panel/card < field.
// Borders are solid hex, not rgba washes — washes stay faint on near-black.
// ----------------------------------------------------------------------
export const UI = {
  bg: '#040502', // page — darkest, back layer
  bgSoft: '#0D0F09',
  panel: '#12140E', // card surface — lifted off page
  card: '#12140E', // was rgba(255,255,255,0.025) — that's why the card blended
  field: '#1C1F16', // field surface — lightest, front layer
  border: '#5A6150', // solid hairline — fields/dividers now visible
  borderStrong: '#6B7360', // bold edge for emphasis
  text: '#FFFFFF', // was #F4F6EF — pure white, max
  textMuted: '#D4DAC8',
  textFaint: '#AEB69E',
  danger: '#F2777A',
  yellow: '#E6E63C',
  green: '#7FD426',
  gradient: 'linear-gradient(90deg, #E9E637 0%, #A6DC2E 48%, #6FCF2C 100%)',
  gradientText: 'linear-gradient(90deg, #E9E637 0%, #8AD62E 100%)',
  mono: '"IBM Plex Mono","SFMono-Regular",ui-monospace,Menlo,Consolas,monospace',
};

export const EMPTY = {};
export const FEE_RATE = 0.035; // was 0.01 — your flat 3.5% (see note)
export const MIN_FEE_USD = 0; // was 2 — no minimum now (see note)

export const CRYPTO_ASSETS = [
  { key: 'usdt-trc20', label: 'USDT', network: 'TRC-20', coingeckoId: 'tether' },
  { key: 'usdt-bep20', label: 'USDT', network: 'BEP-20', coingeckoId: 'tether' },
  { key: 'usdt-erc20', label: 'USDT', network: 'ERC-20', coingeckoId: 'tether' },
  { key: 'btc', label: 'BTC', network: 'Bitcoin', coingeckoId: 'bitcoin' },
  { key: 'eth', label: 'ETH', network: 'Ethereum', coingeckoId: 'ethereum' },
  { key: 'sol', label: 'SOL', network: 'Solana', coingeckoId: 'solana' },
  { key: 'trx', label: 'TRX', network: 'Tron', coingeckoId: 'tron' },
];

export const PAYOUT_PROVIDERS = [
  { key: 'evcplus', label: 'EVC Plus', mark: 'E' },
  { key: 'zaad', label: 'Zaad', mark: 'Z' },
  { key: 'sahal', label: 'Sahal', mark: 'S' },
];
